import React from "react";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { Lock } from "lucide-react";

export default function UpgradeDialog({ navigate, setUpgradeOpen, upgradeOpen }) {
  return (
    <Dialog open={!!upgradeOpen} onOpenChange={(v) => { if (!v) setUpgradeOpen(""); }}>
      <DialogContent className="max-w-md" data-testid="upgrade-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Lock style={{ width: 18, height: 18 }} className="text-primary" /> {upgradeOpen.includes("in pausa") ? "Abbonamento in pausa" : <>Sblocca con il piano Pro <span className="text-[10px] font-bold px-1.5 py-0.5 rounded bg-amber-100 text-amber-700">PRO</span></>}</DialogTitle>
          <DialogDescription data-testid="upgrade-modal-text">{upgradeOpen}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => setUpgradeOpen("")}>Più tardi</Button>
          <Button data-testid="upgrade-modal-cta" onClick={() => navigate("/billing")} className="font-semibold">Scopri i piani Pro</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
